export default {
  // 导航栏
  nav: {
    welcome: '欢迎',
    company: '公司',
    products: '产品',
    links: '联系',
    language: '中文'
  },
  
  // 首页
  home: {
    title: '用 AI 重构微生物检测',
    subtitle1: '保护食品安全',
    subtitle2: '守护生命健康',
    logoAlt: '巴斯德生物科技'
  },
  
  // 公司页面
  company: {
    title: '公司文化',
    mission: '使命',
    missionText: '用 AI 重构微生物检测，保护食品安全，守护生命健康',
    vision: '愿景',
    visionText: '成为全球领先的微生物检测解决方案提供商',
    values: '价值观',
    value1: '创新',
    value1Text: '持续创新，引领技术发展',
    value2: '品质',
    value2Text: '精益求精，追求卓越品质',
    value3: '服务',
    value3Text: '客户至上，提供专业服务',
    // 核心优势
    coreAdvantages: '核心优势',
    advantages: {
      automation: '全自动微生物监测设备',
      aiModel: '微生物垂直大模型',
      pipeline: '病原微生物检测流水线'
    },
    // 关于我们
    about: {
      subtitle: 'ABOUT US',
      title: '公司简介',
      description: [
        '巴斯德（PASTEUR）是一家专注于人工智能微生物检测的高科技企业。我们致力于通过前沿的AI技术，为医疗健康领域提供精准、高效的微生物检测解决方案。',
        '公司汇聚了来自国内外顶尖高校和科研机构的优秀人才，在人工智能、微生物学、医学影像等领域拥有深厚的技术积累。我们的研发团队由多位博士和资深工程师组成，持续推动技术创新和产品升级。'
      ],
      mission: '用 AI 重构微生物检测，保护食品安全，守护生命健康'
    },
    // 品牌故事
    brandStory: {
      subtitle: 'BRAND STORY',
      title: '品牌故事',
      mainTitle: '致敬巴斯德——微生物学，免疫学，公共卫生防疫学奠基人！',
      description: [
        '路易斯·巴斯德（Louis Pasteur，1822年12月27日-1895年9月28日），也称路易·巴斯德，出生于法国东部多尔镇，博士研究生毕业于巴黎大学，免疫学和卫生防疫学的奠基人，法国化学家和微生物学家。',
        '巴斯德年迈时，回到自己的母校演讲，提到他一生在面对如此大的反对，而能节节得胜的因素有两个："信心，相信神的启示，信心是一条绳子，维系你周围所发生的事情，与你内心的呼召，成为一个和谐的关系。"这点显示巴斯德以信心接受神的呼召—在科学战场上为主和圣经争战..第二个得胜的因素是："热心(enthusiasm)，这是最好的字，是En及Theo合成；En是里面，Theo是神。真正持久的热心，是来自神住在我的心里。"'
      ],
      honors: [
        '微生物学的奠基人',
        '巴氏杀菌法的发明者',
        '疫苗的先锋',
        '手性化学的发现者',
        '公共卫生的革命者',
        '科研与实践结合的典范'
      ],
      pasteurAlt: '巴斯德肖像',
      confidenceAlt: '信心与热心'
    },
    // 客户成就
    customerAchievement: '成就客户'
  },
  
  // 产品页面
  products: {
    positioning: '巴斯德定位',
    foreignStatus: '国外现状',
    domesticStatus: '国内现状',
    viewDetails: '查看详情',
    overview: {
      subtitle: '产品概览',
      title: '产品概览',
      description: [
        '巴斯德医疗设备有限公司专注于微生物实验室智能化解决方案的研发与应用。我们的LIMS微生物实验室管理系统获得多项专利，为食品、药品、滤膜等样品检测提供全流程智能化管理。',
        '公司旗下拥有完整的微生物检测产品线，包括样品处理设备、微生物培养孵育设备、微生物计数设备和微生物快检设备，所有产品均具备专利技术优势，实现从样品接收到结果输出的全自动化检测流程。'
      ],
      features: [
        { icon: '🏢', text: 'LIMS系统专利技术，设备兼容性强' },
        { icon: '🧪', text: '倾注法专利，样品处理标准化' },
        { icon: '🌡️', text: '温湿度控制专利，培养环境精准' },
        { icon: '📈', text: '微生物识别专利，计数分类智能化' }
      ],
      stats: [
        { number: '10+', label: '核心专利技术' },
        { number: '4大', label: '产品系列' },
        { number: '90%', label: '自动化覆盖' },
        { number: 'GMP', label: '合规标准' }
      ]
    },
    flagship: {
      subtitle: '核心产品',
      title: '核心产品',
      items: [
        {
          category: 'LIMS管理系统',
          name: 'LIMS微生物实验室管理系统',
          description: '专利技术构建的实验室信息管理系统，实现设备兼容和全流程自动化管理。支持食品、药品、滤膜等样品的标准化检测流程。',
          icon: '🖥️',
          specs: [
            { label: '专利技术', value: 'LIMS系统构建' },
            { label: '设备兼容', value: '全系列设备' },
            { label: '样品支持', value: '食品/药品/滤膜' }
          ],
          tags: ['专利技术', '设备兼容', '全流程管理']
        },
        {
          category: '样品处理设备',
          name: '智能样品处理系统',
          description: '采用倾注法专利技术的样品预处理设备，配备精密温湿度控制系统，确保样品处理的标准化和一致性。',
          icon: '🧫',
          specs: [
            { label: '专利技术', value: '倾注法相关' },
            { label: '温控精度', value: '±0.1°C' },
            { label: '湿度控制', value: '±2% RH' }
          ],
          tags: ['倾注法专利', '温湿度控制', '标准化处理']
        },
        {
          category: '培养孵育设备',
          name: '微生物培养孵育系统',
          description: '集成微生物孵育、厌氧孵育和温湿度控制专利技术，为微生物培养提供最佳生长环境，提高培养效率和成功率。',
          icon: '🦠',
          specs: [
            { label: '专利技术', value: '微生物孵育/厌氧' },
            { label: '温度范围', value: '4-60°C' },
            { label: '培养容量', value: '100-500个样品' }
          ],
          tags: ['微生物孵育专利', '厌氧培养', '精准控温']
        },
        {
          category: '计数识别设备',
          name: '微生物智能计数系统',
          description: '基于微生物计数、识别和分类专利技术的智能化设备，实现菌落的自动识别、计数和分类，大幅提高检测效率。',
          icon: '🔍',
          specs: [
            { label: '专利技术', value: '计数/识别/分类' },
            { label: '识别精度', value: '≥99.5%' },
            { label: '计数速度', value: '<30秒/皿' }
          ],
          tags: ['微生物计数专利', '智能识别', '自动分类']
        },
        {
          category: '快速检测设备',
          name: '微生物快速检测系统',
          description: '集成微生物快检、菌落回收率和GMP相关专利技术，实现微生物的快速检测和质量控制，满足GMP标准要求。',
          icon: '⏱️',
          specs: [
            { label: '专利技术', value: '快检/回收率/GMP' },
            { label: '检测时间', value: '2-8小时' },
            { label: 'GMP合规', value: '100%符合' }
          ],
          tags: ['微生物快检专利', '菌落回收率', 'GMP标准']
        }
      ]
    },
    advantages: {
      subtitle: '技术优势',
      title: '技术优势',
      items: [
        {
          title: 'LIMS系统专利',
          description: '自主研发的LIMS微生物实验室管理系统专利技术，实现设备间无缝兼容和数据互通，构建完整的智能化检测生态。',
          icon: '🔗',
          metrics: [
            { value: '10+', unit: '项', label: 'LIMS专利' },
            { value: '100', unit: '%', label: '设备兼容性' }
          ]
        },
        {
          title: '倾注法专利技术',
          description: '独创的倾注法样品处理专利技术，结合温湿度控制系统，确保样品处理的标准化和重复性。',
          icon: '🌡️',
          metrics: [
            { value: '±0.1', unit: '°C', label: '温控精度' },
            { value: '±2', unit: '%RH', label: '湿度精度' }
          ]
        },
        {
          title: '微生物孵育专利',
          description: '集成微生物孵育和厌氧孵育专利技术，提供最佳培养环境，显著提高微生物检测的准确性和效率。',
          icon: '🥚',
          metrics: [
            { value: '99.5', unit: '%', label: '培养成功率' },
            { value: '24-72', unit: '小时', label: '培养周期' }
          ]
        },
        {
          title: '智能识别专利',
          description: '基于微生物计数、识别和分类专利技术，实现菌落的自动化检测，大幅提升检测效率和准确率。',
          icon: '🎯',
          metrics: [
            { value: '99.5', unit: '%', label: '识别准确率' },
            { value: '<30', unit: '秒', label: '检测速度' }
          ]
        },
        {
          title: '快检技术专利',
          description: '微生物快检、菌落回收率和GMP相关专利技术，实现快速检测同时确保结果符合GMP标准要求。',
          icon: '⚡',
          metrics: [
            { value: '2-8', unit: '小时', label: '快检时间' },
            { value: '100', unit: '%', label: 'GMP合规' }
          ]
        }
      ]
    },
    scenarios: {
      subtitle: '应用场景',
      title: '应用场景',
      items: [
        {
          title: '食品检测',
          brief: '食品微生物安全检测',
          description: '为食品企业提供专业的微生物检测解决方案，通过LIMS系统实现从样品接收到结果输出的全流程管理，确保食品安全。',
          icon: '🍎',
          image: require("@/assets/image/background.png"),
          features: [
            '食品样品LIMS管理',
            '倾注法标准化处理',
            '微生物智能计数',
            'GMP合规快检'
          ]
        },
        {
          title: '药品检测',
          brief: '药品微生物限度检查',
          description: '为制药企业提供符合GMP标准的微生物检测服务，采用专利技术确保药品生产过程中的微生物质量控制。',
          icon: '💊',
          image: require("@/assets/image/background.png"),
          features: [
            '药品样品追踪管理',
            '无菌检查自动化',
            '微生物限度检测',
            'GMP标准合规'
          ]
        },
        {
          title: '滤膜检测',
          brief: '滤膜微生物截留效率测试',
          description: '为滤膜生产企业提供专业的微生物检测服务，通过专利的倾注法和快检技术，评估滤膜的微生物截留性能。',
          icon: '🔬',
          image: require("@/assets/image/background.png"),
          features: [
            '滤膜样品标准化',
            '截留效率检测',
            '菌落回收率测试',
            '数据分析报告'
          ]
        },
        {
          title: '实验室管理',
          brief: '微生物实验室整体解决方案',
          description: '为各类微生物实验室提供LIMS系统和配套设备，实现实验室数字化转型，提升检测效率和管理水平。',
          icon: '🏢',
          image: require("@/assets/image/background.png"),
          features: [
            'LIMS系统部署',
            '设备集成兼容',
            '流程标准化管理',
            '数据资产化管理'
          ]
        }
      ]
    },
    detectionStages: {
      stages: [
        {
          upperText: '传统手工',
          lowerText: '人工检测'
        },
        {
          upperText: '半自动',
          lowerText: '机器检测'
        },
        {
          upperText: '全自动',
          lowerText: '全过程监测'
        },
        {
          upperText: '检测算法AI化',
          lowerText: '检测数据资产化'
        }
      ]
    }
  },
  
  // 链接页面
  links: {
    emailHint: '有任何问题，欢迎随时联系我们',
    contact: {
      subtitle: '联系我们',
      title: '联系我们',
      description: '我们期待与您的合作，共同推进生物科技创新发展',
      items: {
        address: {
          title: '公司地址',
          content: '深圳市龙岗区南湾街道上李朗社区平吉大道61号上李朗智创园H栋厂房202'
        },
        phone: {
          title: '联系电话',
          content: '400 686 3798'
        },
        email: {
          title: '电子邮箱',
          content: 'contact@bioailego.com'
        },
        hours: {
          title: '工作时间',
          content: '周一至周五 9:00-18:30'
        }
      }
    },
    quickContact: {
      title: '快速联系',
      description: '留下您的信息，我们会尽快与您联系'
    },
    form: {
      name: '您的姓名',
      phone: '联系电话',
      email: '电子邮箱',
      message: '请描述您的需求或问题',
      submit: '发送消息',
      successMessage: '感谢您的留言，我们会尽快回复您！'
    }
  },
  
  // 服务协议页面
  terms: {
    title: '服务协议',
    subtitle: '深圳市巴斯德医疗器械有限公司服务条款',
    updateDate: '更新日期',
    version: '版本',
    intro: {
      title: '协议说明',
      content: '欢迎使用巴斯德产品和服务。请您仔细阅读本协议条款。'
    },
    sections: {
      service: {
        title: '服务说明',
        content1: '巴斯德提供专业的微生物检测设备和解决方案：',
        items: [
          'LIMS微生物实验室管理系统',
          '智能样品处理系统',
          '微生物培养孵育系统',
          '微生物智能计数系统'
        ],
        content2: '我们承诺为您提供安全、可靠、高效的检测设备和服务。'
      },
      obligations: {
        title: '用户义务',
        content: '使用巴斯德产品时，请您遵守以下义务：',
        items: [
          '遵守相关法律法规',
          '按说明书正确使用设备',
          '妥善保管设备和资料',
          '及时反馈设备问题'
        ]
      },
      property: {
        title: '知识产权',
        content1: '巴斯德对其产品、软件、商标等享有完整的知识产权。',
        content2: '核心知识产权包括：',
        items: [
          { text: 'LIMS系统专利技术' },
          { text: '管理系统软件著作权' },
          { text: '巴斯德商标权' }
        ]
      },
      privacy: {
        title: '隐私保护',
        content: '巴斯德高度重视用户隐私保护，严格按照法律法规保护您的个人信息。',
        notice: {
          title: '隐私保护承诺',
          content: '我们采用先进技术手段，确保您的个人信息安全。'
        }
      },
      disclaimer: {
        title: '免责声明',
        content: '在法律允许范围内，巴斯德对以下情况不承担责任：',
        items: [
          '用户操作不当导致的设备损坏',
          '不可抗力导致的服务中断',
          '第三方问题导致的服务异常'
        ]
      },
      changes: {
        title: '协议变更',
        content: '巴斯德有权根据业务发展和法律法规变化，对本协议进行修改。修改后的协议将在官网公布并生效。'
      },
      dispute: {
        title: '争议解决',
        content: '因本协议引起的争议，双方应友好协商解决。协商不成的，向巴斯德所在地人民法院提起诉讼。'
      }
    },
    contact: {
      title: '联系我们',
      email: {
        title: '电子邮箱',
        content: 'contact@bioailego.com'
      },
      phone: {
        title: '联系电话',
        content: '400 686 3798'
      },
      address: {
        title: '公司地址',
        content: '深圳市龙岗区南湾街道上李朗智创园7A栋202'
      }
    },
    confirmation: {
      title: '协议确认',
      content: '请您确认已仔细阅读并同意本服务协议的所有条款。',
      accept: '我已阅读并同意',
      print: '打印协议',
      success: '感谢您的确认！'
    }
  },
  
  // 隐私政策页面
  privacy: {
    title: '隐私政策',
    subtitle: '深圳市巴斯德医疗器械有限公司隐私保护条款',
    intro: {
      title: '政策说明',
      content: '深圳市巴斯德医疗器械有限公司（以下简称"巴斯德"或"我们"）深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息。'
    },
    sections: {
      collection: {
        title: '信息收集',
        content: '我们可能收集以下类型的信息，以便为您提供更好的产品和服务：',
        items: [
          {
            title: '个人基本信息',
            description: '包括但不限于姓名、联系电话、电子邮箱、公司名称、职位等，用于身份识别和业务联系。'
          },
          {
            title: '设备信息',
            description: '包括设备型号、序列号、使用记录、维护记录等，用于产品支持和售后服务。'
          },
          {
            title: '技术支持信息',
            description: '包括技术咨询记录、故障报告、维修请求等，用于提供技术支持和产品改进。'
          },
          {
            title: '业务交流信息',
            description: '包括商务洽谈记录、合作意向、需求调研等，用于业务合作和产品定制。'
          }
        ]
      },
      usage: {
        title: '信息使用',
        content: '我们使用收集的信息为您提供以下服务：',
        items: [
          {
            icon: '🛠️',
            text: '产品安装、调试和维护服务'
          },
          {
            icon: '📞',
            text: '技术支持和客户服务响应'
          },
          {
            icon: '📊',
            text: '产品质量跟踪和改进优化'
          },
          {
            icon: '🔧',
            text: '设备故障诊断和远程支持'
          },
          {
            icon: '📈',
            text: '产品功能升级和新功能推送'
          },
          {
            icon: '🤝',
            text: '业务合作和定制化服务'
          }
        ]
      },
      protection: {
        title: '信息保护',
        content: '我们采取多种安全措施保护您的个人信息安全：',
        measures: [
          {
            title: '数据加密',
            description: '采用SSL/TLS加密技术保护数据传输安全，敏感信息采用AES-256加密存储。'
          },
          {
            title: '访问控制',
            description: '实施严格的权限管理制度，只有授权人员才能访问相关个人信息。'
          },
          {
            title: '安全审计',
            description: '定期进行安全审计和漏洞扫描，及时发现和修复安全隐患。'
          },
          {
            title: '数据备份',
            description: '建立完善的数据备份机制，确保数据不会因为意外情况而丢失。'
          }
        ]
      },
      cookies: {
        title: 'Cookie使用',
        content: '我们的网站可能使用Cookie技术来改善用户体验：',
        types: [
          {
            category: '必要Cookie',
            description: '确保网站基本功能正常运行，如用户认证、购物车等。'
          },
          {
            category: '性能Cookie',
            description: '收集网站使用统计信息，帮助我们改善网站性能和用户体验。'
          },
          {
            category: '功能Cookie',
            description: '记住用户的偏好设置，提供个性化的网站体验。'
          },
          {
            category: '营销Cookie',
            description: '用于展示相关的广告内容和营销信息。'
          }
        ]
      },
      rights: {
        title: '用户权利',
        content: '根据相关法律法规，您享有以下权利：',
        items: [
          {
            title: '知情权',
            description: '您有权了解我们收集、使用您个人信息的方式和目的。'
          },
          {
            title: '访问权',
            description: '您有权访问我们持有的关于您的个人信息。'
          },
          {
            title: '更正权',
            description: '当您的个人信息发生变化时，您有权要求我们进行更新或更正。'
          },
          {
            title: '删除权',
            description: '在符合法律法规的前提下，您有权要求我们删除您的个人信息。'
          },
          {
            title: '可携带权',
            description: '您有权以结构化、通用格式获取您的个人信息副本。'
          }
        ]
      },
      sharing: {
        title: '第三方共享',
        content: '除法律法规另有规定外，我们不会向第三方共享、转让您的个人信息。我们仅会在以下情况下共享您的信息：',
        notice: {
          title: '重要提示',
          content: '我们要求所有第三方合作伙伴严格遵守本隐私政策，并采取足够的安全措施保护您的个人信息安全。'
        }
      },
      updates: {
        title: '政策更新',
        content: '我们可能会根据法律法规变化、业务发展需要或技术进步等情况，适时更新本隐私政策。更新后的政策将在官网发布，并自发布之日起生效。请您定期查看本政策以了解最新信息。'
      }
    }
  },
  
  // 合作洽谈页面
  cooperation: {
    title: '合作洽谈',
    subtitle: '携手共创美好未来',
    description: '我们期待与各行各业的优秀伙伴建立长期稳定的合作关系，共同推动生物医疗产业的发展与创新。',
    process: {
      title: '合作流程',
      subtitle: '简单高效的合作流程，让合作更加顺畅',
      steps: [
        {
          number: '01',
          title: '初步接触',
          description: '通过电话、邮件或在线表单与我们取得联系，了解合作意向和基本需求'
        },
        {
          number: '02',
          title: '需求评估',
          description: '我们的专业团队将详细了解您的需求，进行可行性分析和方案设计'
        },
        {
          number: '03',
          title: '方案洽谈',
          description: '双方就合作方案进行深入讨论，明确合作模式、责任分工和利益分配'
        },
        {
          number: '04',
          title: '协议签订',
          description: '达成一致后签订正式合作协议，确立双方权利义务关系'
        },
        {
          number: '05',
          title: '项目实施',
          description: '按照协议约定开展合作项目，定期沟通进展，确保项目顺利推进'
        },
        {
          number: '06',
          title: '持续支持',
          description: '项目完成后提供持续的技术支持和售后服务，建立长期合作关系'
        }
      ]
    },
    form: {
      title: '联系我们',
      subtitle: '请填写以下信息，我们将尽快与您联系',
      name: '姓名',
      namePlaceholder: '请输入您的姓名',
      company: '公司名称',
      companyPlaceholder: '请输入您的公司名称',
      phone: '联系电话',
      phonePlaceholder: '请输入您的联系电话',
      email: '邮箱地址',
      emailPlaceholder: '请输入您的邮箱地址',
      cooperationType: '合作类型',
      selectType: '请选择合作类型',
      message: '合作需求',
      messagePlaceholder: '请详细描述您的合作需求...',
      submit: '提交咨询',
      submitting: '提交中...',
      reset: '重置表单',
      successMessage: '提交成功！我们会尽快与您联系。',
      types: {
        distribution: '产品经销',
        technical: '技术合作',
        research: '研发合作',
        investment: '投资合作',
        strategic: '战略合作',
        other: '其他合作'
      }
    }
  },
  
  // 错误页面
  error: {
    title: '页面未找到',
    description: '抱歉，您访问的页面不存在或已被移除，请检查网址是否正确',
    backHome: '返回首页'
  }
}